module.exports = __webpack_public_path__ + "img/DOCX_document_icon@2x.6f1e07d1.png";